export const GRID_BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1500,
} as const;

export const CONTAINER_MAX_WIDTHS = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140,
  xxl: 1400,
} as const;

export const DEVICES = {
  mobile: 'sm',
  tablet: 'md',
  desktop: 'xl',
} as const;

export const VIEWPORT = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
} as const;

export const PAGE_TYPE = {
  Blog: 'Blog',
  BlogPost: 'BlogPost',
  LifeBlog: 'LifeBlog',
  LifeBlogPost: 'LifeBlogPost',
  Academy: 'Academy',
  AcademyArticle: 'AcademyArticle',
  Default: 'Bunny.net',
  NotFound: '404',
} as const;

export const PAGE_PREFIX = {
  Blog: 'blog',
  LifeBlog: 'life-at-bunny',
  Academy: 'academy',
} as const;

export const THEMES = {
  LIGHT_BLUE: 'light-blue',
  DARK_BLUE: 'dark-blue',
};

export const DEFAULT_ALL_POSTS = 'All Posts';

export const BUNNY_AUTHOR = 'bunny.net';
export const BUNNY_FB = 'https://www.facebook.com/bunnycdn';
export const BUNNY_TW = '@bunnycdn';
export const OG_IMAGE_WIDTH = 1280;
export const OG_IMAGE_HEIGHT = 628;

export const MAX_META_DESCRIPTION_LENGTH = 325;
export const INQUIRY_LIMIT = 1000;

export const COMING_SOON = 'Coming soon';
export const ENTERPRISE_DRM = 'Enterprise DRM';
export const STYLE_2024 = '2024-rework';

export const ARTICLE_NODE_TYPE = 'AcademyArticles';
export const CATEGORIES_NODE_TYPE = 'AcademyCategories';
export const GLOSSARY_NODE_TYPE = 'GlossaryItems';
export const FEATURED_NODE_TYPE = 'AcademyFeatured';

export const TITLE_SIZE = 4.5;
export const TEXT_SIZE = 1.8;
export const SUBTITLE_SIZE = 2.9;
export const PARAGRAPH_SIZE = 1.8;
export const TEXT_COLOR = '#183d6d';

export const NODE_TYPE = {
  Blog: {
    Tag: 'Blog__Tag',
    Post: 'Blog__Post',
  },
  LifeBlog: {
    Tag: 'LifeBlog__Tag',
    Post: 'LifeBlog__Post',
  },
} as const;
